module.exports = __webpack_public_path__ + "assets/img/structure-de7eaf53.png";